exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".d-block[data-v-5888ca86] {\n  max-height: 233px;\n}\n.detail[data-v-5888ca86] {\n  padding-top: 10px !important;\n  padding-bottom: 10px !important;\n}\n.detail .news-abstract[data-v-5888ca86] {\n  height: 80px;\n  overflow: hidden;\n}\n.carousel-indicators[data-v-5888ca86] {\n  padding: 0px !important;\n}\n.photo[data-v-5888ca86] {\n  height: 140px;\n}\n.VueCarousel-slide[data-v-5888ca86] {\n  text-align: left;\n}\n[data-v-5888ca86] .VueCarousel-navigation-button {\n  top: 40% !important;\n}", ""]);

// exports
